import type { NavigateFunction } from 'react-router-dom';
import { SecondarySidebar, SecondarySidebarSection, type AppLayoutApi } from '@jordan/ui';

const ITEMS = [
  { label: 'Scores', icon: 'ph-note-pencil', path: '/health/golf/scores' },
  { label: 'Stats', icon: 'ph-chart-pie-slice', path: '/health/golf/stats' },
  { label: 'Activity', icon: 'ph-list-bullets', path: '/health/golf/activity' },
  { label: 'Tee Times', icon: 'ph-calendar-check', path: '/health/golf/tee-times' },
  { label: 'Import', icon: 'ph-upload-simple', path: '/health/golf/import' },
] as const;

/**
 * Shared secondary (left) sidebar for the Golf section — the same Activity/Import nav on every
 * Golf page. `isActive` decides which item is highlighted (the Activity item stays active on the
 * activity-summary route too).
 */
export function golfSidebar(navigate: NavigateFunction, pathname: string) {
  return function GolfSecondarySidebar(api: AppLayoutApi) {
    const go = (path: string) => {
      navigate(path);
      api.closeSecondarySidebar();
    };
    return (
      <SecondarySidebar title="Golf" mobileExpanded={api.secondarySidebarExpanded} onClose={api.closeSecondarySidebar}>
        <SecondarySidebarSection title="Golf" flush>
          <ul className="nav nav-sidebar my-2" data-nav-type="accordion">
            {ITEMS.map((it) => {
              const active =
                it.path === '/health/golf/activity'
                  ? pathname.startsWith('/health/golf/activity')
                  : pathname === it.path;
              return (
                <li className="nav-item" key={it.path}>
                  <a
                    href={it.path}
                    className={`nav-link ${active ? 'active' : ''}`.trim()}
                    onClick={(e) => {
                      e.preventDefault();
                      go(it.path);
                    }}
                  >
                    <i className={`${it.icon} me-3`} />
                    {it.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </SecondarySidebarSection>
      </SecondarySidebar>
    );
  };
}
